import Swal from "sweetalert2";

export function openBase64NewTab(base64Pdf) {
  var blob = base64toBlob(base64Pdf);
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, "pdfBase64.pdf");
  } else {
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  }
}
export function base64toBlob(base64Data) {
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: "application/pdf" });
}

export function htmlToElement(html) {
  var template = document.createElement("template");
  html = html.trim(); // Never return a text node of whitespace as the result
  template.innerHTML = html;
  return template.content.firstChild;
}

export function getElementFromTemplate(teplateId) {
  var temp = document.getElementById(teplateId);
  var html = temp.innerHTML;

  var materializedTemplate = document.createElement("template");
  materializedTemplate.innerHTML = html.trim();

  return materializedTemplate.content.firstChild;
}

export function getPos(element) {

  var position = {
    top: element.offsetTop,
    left: element.offsetLeft,
  };

  return position;
}
export function getPosRelative(element, relativeelement) {
  // Get the top, left coordinates of two elements
  const eleRect = element.getBoundingClientRect();
  const targetRect = relativeelement.getBoundingClientRect();

  // Calculate the top and left positions
  const top = eleRect.top - targetRect.top;
  const left = eleRect.left - targetRect.left;
  const right = targetRect.right - eleRect.right;
  const bottom = targetRect.bottom - eleRect.bottom;
  var position = {
    top,
    left,
    right,
    bottom,
  };
  return position;
}

export function getRotate(transform) {
  var re = /rotate\(.*deg\)/i; //regex to match rotateZ(...deg)

  const degE = re.exec(transform);
  if (degE && degE.length > 0) {
    const oldDegree = degE[0];

    return oldDegree;
  }

  return null;
}

export function applyStyles(element, styles) {
  Object.keys(styles).forEach((key) => {
    element.style[key] = styles[key];
  });
}

export function toggleLoader(state) {
  $("#loader").toggleClass("is-active", state);
}

export function initAlerts() {
  $('.alert[data-delay][data-delay!="0"]').each(function (index, alrt) {
    $(alrt).slideDown(300).delay($(alrt).data("delay")).slideUp(300, function () {

    });
  });
}

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

export function initConfirmDelete() {

  function defferOnClick($el) {
    // Check if element has onclick attribute. If so then store in the data to deffer the action
    if ($el.prop('onclick')) {
      var f = $el.prop('onclick');
      $el.removeAttr('onclick')
      $el.off('click', f);
      $el.data('deffered-click', f);
    }
  }
  $("[confirm-delete]").not("[confirmation-active]").each(function (i, el) {
    var $el = $(el);

    $el.attr("confirmation-active", "true");
    defferOnClick($el);


    $el.on("click", function (event) {
      var _this = this;
      var $this = $(this);

      if ($this.data("dontAskToConfirm")) {


        return true;
      }
      else {

        event.preventDefault();
        event.stopPropagation();

        var text = "this record";
        if ($this.attr("confirm-delete") != "" && $this.attr("confirm-delete") != null) {
          text = ("'" + $this.attr("confirm-delete") + "'");
        }


        Swal.fire({
          title: "Confirm delete",
          text: "Are you sure you want to delete " + text + "? ",
          icon: "warning",
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Delete',
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonColor:'#d33'

        }).then(function (v) {

          if (v.isConfirmed) {
            $this.data("dontAskToConfirm", true);
            if ($this.data('deffered-click')) {
              //$this.on('click', $this.data('deffered-click'));
              var f = $this.data('deffered-click');
              f();

              $this.data("dontAskToConfirm", false);
              return true;

            }
            if ($this[0].nodeName == "A") {

              $this[0].click();
            } else {
              $this.click();
            }
          }


          //swal("Deleted!", "Your imaginary file has been deleted.", "success");
        });

        return false;
      }

    })
  });
}